import { render, staticRenderFns } from "./MaskInput.vue?vue&type=template&id=2afebe03&scoped=true&"
import script from "./MaskInput.vue?vue&type=script&lang=js&"
export * from "./MaskInput.vue?vue&type=script&lang=js&"
import style0 from "./MaskInput.vue?vue&type=style&index=0&id=2afebe03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afebe03",
  null
  
)

export default component.exports